"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTheme = _interopRequireDefault(require("@material-ui/styles/useTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const UiPreloader = _ref => {
  let {
    width = "64px"
  } = _ref;
  const theme = (0, _useTheme.default)();
  const {
    palette: {
      primary: {
        main
      }
    }
  } = theme;
  return /*#__PURE__*/_react.default.createElement("svg", {
    style: {
      display: "block",
      width: width
    },
    version: "1.1",
    id: "L9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 0 0",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: main,
    d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
  }, /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })));
};
var _default = exports.default = UiPreloader;